// extracted by mini-css-extract-plugin
export var diamondIcon = "QuaddieSelection-module--diamondIcon--a24d8";